module.exports = __webpack_public_path__ + "img/menu.899098ef.svg";